// Single source of truth for the product wordmark used in the UI shell.
// Sprint 7.1 introduced this constant so future code cannot drift back to
// the legacy in-app brand string by accident; every visible string is
// sourced here.
//
// Manifest, browser tab title, and PWA `<meta name="apple-mobile-web-app-title">`
// already moved to the canonical product name in Sprint 7 (deploy). This
// file covers the React surface — TopBar wordmark, login page heading,
// and any future branded strings.

export const PRODUCT_NAME = 'As Oasis';
